import type { SVGProps } from 'react';

const SvgSort = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M9.29 14.29 8 15.58V6c0-.55-.45-1-1-1s-1 .45-1 1v9.59L4.71 14.3a.996.996 0 1 0-1.41 1.41l3 3c.2.2.45.29.71.29s.51-.1.71-.29l3-3a.996.996 0 1 0-1.41-1.41zm11.42-6-3-3a.996.996 0 0 0-1.41 0l-3 3a.996.996 0 1 0 1.41 1.41L16 8.41V18c0 .55.45 1 1 1s1-.45 1-1V8.41l1.29 1.29c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41"
    />
  </svg>
);
export default SvgSort;
